import angular from 'angular';
import constants from 'app/constants';
import {
  oversightDataService,
  oversightSharedModelService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';

import controller from './agendaItem-followup.controller';
import directive from './agendaItem-followup.directive';


export default angular.module('app.components.advisory.oversight.agendaItemFollowup', [
  alerts,
  oversightDataService,
  oversightSharedModelService,
  confirmDialog,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('agendaItemFollowup', directive)
  .controller('AgendaItemFollowupController', controller)
  .name;

console.log('app.components.advisory.oversight.agendaItemFollowup created');
